import componentI18n from '@/i18n/componentI18n';
export default {
    name: 'IceBreakerDialog',
    ...componentI18n('components.lobby.ice_breakers.dialog')
};
